'use strict';
/**
 * Dependencies
 * @ignore
 */

var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var base64url = require('base64url');

var crypto = require('isomorphic-webcrypto');

var TextEncoder = require('../text-encoder');
/**
 * HMAC with SHA-2 Functions
 */


var HMAC = /*#__PURE__*/function () {
  /**
   * Constructor
   *
   * @param {string} bitlength
   */
  function HMAC(params) {
    _classCallCheck(this, HMAC);

    this.params = params;
  }
  /**
   * Sign
   *
   * @description
   * Generate a hash-based message authentication code for a
   * given input and key. Enforce the key length is equal to
   * or greater than the bitlength.
   *
   * @param {CryptoKey} key
   * @param {string} data
   *
   * @returns {string}
   */


  _createClass(HMAC, [{
    key: "sign",
    value: function sign(key, data) {
      var algorithm = this.params; // TODO: validate key length

      data = new TextEncoder().encode(data);
      return crypto.subtle.sign(algorithm, key, data).then(function (signature) {
        return base64url(Buffer.from(signature));
      });
    }
    /**
     * Verify
     *
     * @description
     * Verify a digital signature for a given input and private key.
     *
     * @param {CryptoKey} key
     * @param {string} signature
     * @param {string} data
     *
     * @returns {Boolean}
     */

  }, {
    key: "verify",
    value: function verify(key, signature, data) {
      var algorithm = this.params;

      if (typeof signature === 'string') {
        signature = Uint8Array.from(base64url.toBuffer(signature));
      }

      if (typeof data === 'string') {
        data = new TextEncoder().encode(data);
      }

      return crypto.subtle.verify(algorithm, key, signature, data);
    }
    /**
     * Assert Sufficient Key Length
     *
     * @description Assert that the key length is sufficient
     * @param {string} key
     */

  }, {
    key: "assertSufficientKeyLength",
    value: function assertSufficientKeyLength(key) {
      if (key.length < this.bitlength) {
        throw new Error('The key is too short.');
      }
    }
  }]);

  return HMAC;
}();
/**
 * Export
 */


module.exports = HMAC;